// Add this JavaScript to your theme's JavaScript file
document.addEventListener('DOMContentLoaded', function() {
  function updateCountdown() {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();

    // Define the start and end times (9 AM to 3 PM)
    const startHour = 9;
    const endHour = 15;

    let targetTime;
    
    if (hours >= startHour && hours < endHour) {
      // During the countdown period (9 AM to 3 PM)
      targetTime = new Date(now);
      targetTime.setHours(endHour, 0, 0, 0); // 3 PM
    } else if (hours < startHour) {
      // Before the countdown period starts
      targetTime = new Date(now);
      targetTime.setHours(startHour, 0, 0, 0); // 9 AM
    } else {
      // After the countdown period ends, set to next day 9 AM
      targetTime = new Date(now);
      targetTime.setDate(now.getDate() + 1);
      targetTime.setHours(startHour, 0, 0, 0); // Next day's 9 AM
    }

    // Calculate time remaining
    const timeRemaining = targetTime - now;
    const hoursRemaining = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutesRemaining = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    const secondsRemaining = Math.floor((timeRemaining % (1000 * 60)) / 1000);

    // Display the result
    const timerDisplay = document.getElementById('timer-display');
    if (timerDisplay) {
      timerDisplay.textContent = `${hoursRemaining}h ${minutesRemaining}m ${secondsRemaining}s`;
    }
  }

  // Update the countdown every second
  setInterval(updateCountdown, 1000);
});




// popup 

function moreDetails() {
    var popup = document.getElementById("comboPopup");
          var span = document.getElementsByClassName("close")[0];
          popup.style.display = "block";
      
          span.onclick = function() {
            popup.style.display = "none";
          }
      
          window.onclick = function(event) {
            if (event.target == popup) {
              popup.style.display = "none";
            }
          }
}